import { ROLE_PRECEDENCE } from 'consts';

import { MembershipRole } from 'types/Changemkr';

export function hasPrivilege(role?: MembershipRole, privilege?: MembershipRole) {
  return ROLE_PRECEDENCE[role ?? 'member'] >= ROLE_PRECEDENCE[privilege ?? 'member'];
}

export default hasPrivilege;
